/* eslint-disable consistent-return */
/* eslint-disable camelcase */
import get from 'lodash/get';

const asyncActionCreator = ({ dispatch }) => next => async action => {
  const {
    isAsyncCall,
    baseType,
    asyncCall,
    payload = {},
    afterSuccessCall = () => {},
    afterFailureCall = () => {},
  } = action;

  if (!isAsyncCall) {
    return next(action);
  }

  if (typeof asyncCall !== 'function') {
    throw new Error('Expected asyncCall to be a function.');
  }

  try {
    dispatch({
      type: `${baseType}_REQUEST`,
      payload,
    });
    const response = await asyncCall(dispatch);
    const { status } = response || {};
    if (status === 200 || status === 201) {
      dispatch({
        type: `${baseType}_SUCCESS`,
        payload,
        response: response.data || {},
      });
      afterSuccessCall(dispatch, response);
    } else {
      dispatch({
        type: `${baseType}_FAILURE`,
        payload,
        error: response,
      });
      afterFailureCall(dispatch, response);
    }
  } catch (error) {
    const errorObj = get(error, 'response.data') || {};
    dispatch({
      type: `${baseType}_FAILURE`,
      payload,
      error: errorObj,
    });
    afterFailureCall(dispatch, errorObj);
  }
};

export default asyncActionCreator;
